import { matrixDefaultUrls } from '@/app/env'
import { writeMatrix } from '@/app/matrix'
import type { MatrixOverride, MatrixService } from '@/app/matrix'
import type { MatrixFormValues } from '@/features/matrix/types/matrix-form'

// Store only the services whose chosen URL differs from the un-overridden
// default, then reload so the boot-time env resolution picks the override up.
// writeMatrix drops an empty override from storage entirely.
export function saveMatrixOverride(values: MatrixFormValues) {
  const next: MatrixOverride = {}
  for (const [service, url] of Object.entries(values) as [MatrixService, string][]) {
    if (url !== matrixDefaultUrls[service]) next[service] = url
  }
  writeMatrix(next)
  window.location.reload()
}

export function resetMatrixOverride() {
  writeMatrix(null)
  window.location.reload()
}
